import React, {FC, useEffect, useState} from "react"
import {Grid} from "react-bootstrap"

import {RouteComponentProps, withRouter} from "react-router-dom"
import CultureHub from "../components/NewHomePage/CultureHub"
import Content from "../components/NewHomePage/Content"

interface Props extends RouteComponentProps {}

const PlatformHomepage: FC<Props> = ({location}) => {
  const [isCHEditing, setIsCHEditing] = useState(false)

  useEffect(() => {
    setIsCHEditing(location.editCultureHub)
  }, [location])

  return (
    <Grid>
      <Content showOverlay={isCHEditing} />
      <CultureHub setIsCHEditing={setIsCHEditing} isCHEditing={isCHEditing} />
    </Grid>
  )
}

export default withRouter(PlatformHomepage)
